import {buildActionObject} from "../../../utils/actions_utils";
import {COMMAND_RESET} from "../../../values/action_types";

export const resetCommandStatus = () => buildActionObject(COMMAND_RESET);